// Bloco de anexos (comprovantes) da conciliação, extraído do ConciliacaoModal
// para ser reaproveitado pelo Contestar do MeuFrete (PO1-3222). As regras de
// tipo, tamanho e quantidade ficam em formatters (ANEXO_* / juntarAnexos).
import React, { useRef } from "react";
import { Button, FormGroup, Label } from "reactstrap";

import { ANEXO_ACCEPT, ANEXO_MAX_ARQUIVOS, juntarAnexos } from "./formatters";

const fmtTamanho = (bytes) => {
  const kb = (bytes || 0) / 1024;
  return kb < 1024 ? `${Math.round(kb)} KB` : `${(kb / 1024).toFixed(1)} MB`;
};

export default function AnexosCampo({ arquivos, onChange, onErro, disabled, label }) {
  const fileInputRef = useRef(null);
  const lista = arquivos || [];
  const cheio = lista.length >= ANEXO_MAX_ARQUIVOS;

  const adicionar = (fileList) => {
    const novos = Array.from(fileList || []);
    if (!novos.length) return;
    const { arquivos: combinados, erro } = juntarAnexos(lista, novos);
    onChange(combinados);
    if (onErro) onErro(erro);
  };

  const remover = (idx) => onChange(lista.filter((_, i) => i !== idx));

  return (
    <FormGroup>
      <Label>{label || `Anexos (comprovante) — opcional, até ${ANEXO_MAX_ARQUIVOS}`}</Label>
      <div>
        <input
          ref={fileInputRef}
          type="file"
          multiple
          accept={ANEXO_ACCEPT}
          style={{ display: "none" }}
          disabled={disabled || cheio}
          onChange={(e) => {
            const files = e.target.files;
            adicionar(files);
            e.target.value = "";
          }}
        />
        <Button
          outline
          color="primary"
          size="sm"
          disabled={disabled || cheio}
          onClick={() => fileInputRef.current && fileInputRef.current.click()}
        >
          <i className="tim-icons icon-cloud-upload-94" />{" "}
          {cheio ? `Limite de ${ANEXO_MAX_ARQUIVOS} atingido` : "Selecionar arquivos"}
        </Button>
      </div>
      <small className="text-muted" style={{ display: "block", marginTop: 4 }}>
        PDF, JPG, PNG, XLSX, MSG ou EML · até 10 MB cada.
      </small>
      {lista.length > 0 && (
        <ul className="conf-fatura-anexos-lista">
          {lista.map((f, i) => (
            <li key={`${f.name}-${i}`}>
              <span className="conf-fatura-anexo-nome">
                {f.name} <em>({fmtTamanho(f.size)})</em>
              </span>
              <button
                type="button"
                className="conf-fatura-anexo-remover"
                onClick={() => remover(i)}
                disabled={disabled}
                aria-label={`Remover ${f.name}`}
              >
                ×
              </button>
            </li>
          ))}
        </ul>
      )}
    </FormGroup>
  );
}
